import GetSafetyHookByIdRequestModelBase from '../_generated/modelBases/get-safety-hook-by-id-request-model-base';

export default class GetSafetyHookByIdRequestModel extends GetSafetyHookByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
